import { fleetDefaultFilters } from '../constants/FleetDefaultFilters';
import { AUTH_LOGIN, FLEET_LOADED, SET_FLEET_OVERRIDE, SET_TIMEZONE } from '../constants/action-types';
import { Event, Fleet } from '../interfaces';
import { AppState } from '../reducers';
import { FleetService, UserService } from '../services';
import { timezonesEnum } from '../utils';
import { getDefaultDates } from '../utils/timezoneHelpers';
import { setDefaultFilter, updateFilterPartial } from './eventFiltersActions';

export function setLoadedFleet(fleet: Fleet) {
  return {
    type: FLEET_LOADED,
    fleet,
  };
}

export function refreshFleet(isInit?: boolean) {
  return function (dispatch: any, getState: () => AppState) {
    const { store } = getState();

    UserService.isInternal()
      .then((isInternal) => {
        const fleetIdFromUrl = new URL(document.URL).searchParams.get('fleet_id');
        if (fleetIdFromUrl) {
          dispatch(setFleetOverride(fleetIdFromUrl)); // it updates fleetooverride when we got different fleet from link.
          // Unnecessary, but it better to make current state in sync
        }
        const fleetId = fleetIdFromUrl || store.currentSelectedFleetID;

        if (isInternal && fleetId) {
          return FleetService.get(fleetId);
        }
        return FleetService.getMyFleet();
      })
      .then((fleet) => {
        if (isInit) {
          dispatch(setDefaultFilter(fleet.id));
        } else {
          dispatch(updateFilterPartial(fleetDefaultFilters(fleet.id)));
        }
        dispatch(setLoadedFleet(fleet));

        dispatch(setTimezone(fleet.timezone));

        // only dispatch the login action if we're initializing the app - and make it AFTER the fleet is loaded
        // so that all components of the app can access the fleet object
        if (isInit) {
          dispatch({
            type: AUTH_LOGIN,
            isAuthenticated: true, // todo: make normal actions for app init and separate fleet update from auth logic
          });
        }
      });
  };
}

export function setFleetOverride(fleetID: string) {
  return {
    type: SET_FLEET_OVERRIDE,
    fleetID,
  };
}

export function setTimezone(timezone: string) {
  return (dispatch: any, getState: () => AppState) => {
    dispatch(updateFilterPartial(getDefaultDates(timezone || timezonesEnum.AMERICA_LOS_ANGELES)));
    dispatch({ type: SET_TIMEZONE, timezone });
  };
}
